import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import EditIcon from '@material-ui/icons/Edit'

import useFetchAsJson from '@eig-builder/core-utils/hooks/useFetchAsJson'

import IconButton from 'core/components/icon-button'

import { getCrmApiOptions } from '../../../helpers/fetch-options-helper'
import VerticalEditModal from './vertical-edit-modal'
import { DataElementLocations } from '@eig-builder/core-utils/helpers/tagging-helper'

const VerticalWrapper = styled.div`
  .icon {
    display: none;
  }

  :hover {
    .icon {
      display: inline;
      position: absolute;
      right: 0;
    }
  }
`

const VerticalInfo = ({ account }) => {
  const [showEditModal, setShowEditModal] = useState(false)

  const verticalApiOptions = getCrmApiOptions(account, '/v1.0/vertical')
  const [getVerticalReq, getVerticalData] = useFetchAsJson(verticalApiOptions)

  const refetchVerticalData = useCallback(() => {
    getVerticalData(verticalApiOptions)
  }, [verticalApiOptions])

  const openEditModal = () => setShowEditModal(true)
  const closeEditModal = () => setShowEditModal(false)

  if (!getVerticalReq.data) {
    return null
  }

  return <>
    <VerticalWrapper>
      <div className='icon'>
        <IconButton
          icon={<EditIcon />}
          onClick={openEditModal}
          dataElementLocation={DataElementLocations.BODY}
          dataElementLabel='cst-account-details--edit-vertical-icon'
          dataElementId='cst-account-details--edit-vertical-icon'
         />
      </div>
      <div>Vertical: {getVerticalReq.data.vertical}</div>
      <div>Category: {getVerticalReq.data.category}</div>
    </VerticalWrapper>
    {showEditModal &&
      <VerticalEditModal
        account={account}
        handleClose={closeEditModal}
        refetchVerticalData={refetchVerticalData}
        verticalData={getVerticalReq.data}
      />}
  </>
}

VerticalInfo.propTypes = {
  account: PropTypes.object.isRequired
}

export default VerticalInfo
